import { FORM_FIELDS } from '../../../../../../../../constants';
import { getValidationSchema } from '../../../../../../../form/common.validators';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.EMPLOYMENT_TYPE,
        FORM_FIELDS.EMPLOYER_TYPE,
        FORM_FIELDS.UNEMPLOYMENT_REASON,
        FORM_FIELDS.ANOTHER_UNEMPLOYMENT_REASON,
        FORM_FIELDS.ORGANIZATION_NAME,
        FORM_FIELDS.LAST_EXPERIENCE_START_MONTH,
        FORM_FIELDS.LAST_EXPERIENCE_START_YEAR,
        FORM_FIELDS.WORK_PHONE,
        FORM_FIELDS.WORK_ADDRESS,
        FORM_FIELDS.AREA_OF_EMPLOYMENT,
        FORM_FIELDS.JOB_TITLE,
        FORM_FIELDS.JOB_TYPE,
        FORM_FIELDS.SENIORITY,
        FORM_FIELDS.MONTHLY_SALARY,
    ]);
